module.exports = __webpack_public_path__ + "img/action-4.7f6d946e.svg";